import React from 'react';
import { FileText } from 'lucide-react';
import './Documentation.css';

const Documentation = () => {
  return (
    <section className="documentation section" id="documentation" data-testid="documentation-section">
      <div className="container">
        <div className="documentation-content">
          <div className="documentation-icon">
            <FileText size={48} />
          </div>
          <h2 className="documentation-title">Documentation</h2>
          <p className="documentation-status">Documentation coming soon.</p>
          <p className="documentation-contact">
            For technical inquiries contact:<br />
            <a href="mailto:contact@vantasignal.app" className="documentation-email">
              contact@vantasignal.app
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Documentation;
